import { render, staticRenderFns } from "./e-end-privacy.vue?vue&type=template&id=64645cc1&"
import script from "./e-end-privacy.vue?vue&type=script&lang=js&"
export * from "./e-end-privacy.vue?vue&type=script&lang=js&"
import style0 from "./e-end-privacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports